<template>
	<div class="giftcard-options">
		<div class="mb-12">
			<buy-giftcard-select-amount v-model="form.amount" class="mb-3" />

			<v-list three-line style="position: relative">
				<v-subheader class="px-0">Velg type gavekort</v-subheader>
				<transition name="scroll-y-transition" mode="out-in">
					<v-list-item-group v-model="form.deliveryMethod" color="primary" mandatory v-if="deliveryOptions.length">
						<v-list-item v-for="option in deliveryOptions" :key="option.deliveryMethod" :title="option.title" class="giftcard-options__list-item" :value="option.deliveryMethod">
							<div v-if="$vuetify.breakpoint.smAndUp" style class="pr-3">
								<v-icon class="px-3" large v-if="!option.imageUrl" v-text="option.icon"></v-icon>
								<img v-if="option.imageUrl" style="max-width:100px;" :src="option.imageUrl" alt="Gavekort presentasjon" />
							</div>

							<v-list-item-content>
								<v-list-item-title class="font-weight-bold giftcard-options__title">
									<v-icon left>{{ form.deliveryMethod == option.deliveryMethod ? 'radio_button_checked' : 'radio_button_unchecked' }}</v-icon>
									{{ option.title }}
								</v-list-item-title>
								<v-list-item-subtitle v-if="$vuetify.breakpoint.smAndUp">{{ option.description }}</v-list-item-subtitle>
								<v-list-item-subtitle v-else class="giftcard-options__subtitle">
									<v-row>
										<v-col cols="auto" v-if="$vuetify.breakpoint.xsOnly" class="py-0 pr-0">
											<v-list-item-icon class="giftcard-options__icon ma-0">
												<v-icon v-if="!option.imageUrl" v-text="option.icon"></v-icon>
												<img style="max-width:64px;" v-if="option.imageUrl" :src="option.imageUrl" alt="Gavekort presentasjon" />
											</v-list-item-icon>
										</v-col>
										<v-col class="py-0">
											<v-list-item-action class="font-weight-bold d-block mx-0 mt-0 mb-1" v-if="$vuetify.breakpoint.xsOnly">+ kr {{ option.priceIncVat | currency }},-</v-list-item-action>
											<small>{{ option.description }}</small>
										</v-col>
									</v-row>
								</v-list-item-subtitle>
							</v-list-item-content>
							<v-list-item-action class="font-weight-bold" v-if="$vuetify.breakpoint.smAndUp">+ kr {{ option.priceIncVat | currency }},-</v-list-item-action>
						</v-list-item>
						<!--<p v-if="giftcard.deliveryMethod == 0" style="font-style:italic; color:red; font-size: 12px; padding: 10px 0px 0px 0px">* Ved valg av gavekort levert med Posten bør bestilling gjøres innen 16. desember kl. 14:00 for å sikre levering før julaften </p>-->
					</v-list-item-group>
				</transition>

				<v-overlay absolute :value="!!loading">
					<v-progress-circular indeterminate size="64"></v-progress-circular>
				</v-overlay>
			</v-list>

			<!-- <v-subheader v-if="deliveryOptions.length == 1" class="px-0">Muligheten for å velge mellom flere gavekort kommer senere.</v-subheader> -->
		</div>

		<v-btn color="primary" depressed @click="currentStep++" :disabled="!valid">Gå videre</v-btn>
	</div>
</template>

<script>
import BuyGiftcardSelectAmount from './child-components/SelectAmount';
import { GiftCardPurchaseDetails } from '@/services/models';
import { isEqual } from 'lodash-es';

export default {
	name: 'buy-giftcard-options',
	components: { BuyGiftcardSelectAmount },
	props: {
		giftcard: GiftCardPurchaseDetails,
		value: null // Current step
	},
	data() {
		return {
			form: null,
			loading: 0
		};
	},
	computed: {
		valid: function() {
			return this.isAmountValid(this.form.amount) && this.form.deliveryMethod > -1;
		},
		currentStep: {
			get() {
				return this.value || -1;
			},

			set(value) {
				this.$emit('input', value);
			}
		},
		deliveryOptions() {
			return this.$store.state.giftcard.deliveryOptions || [];
		}
	},
	methods: {
		isAmountValid: function(amount) {
			return amount >= 100 && amount <= 20000 && amount.toString().indexOf('.') == -1 && !/^0/.test(amount.toString());
		},
		async fetchDeliveryOptions() {
			if (!this.deliveryOptions.length) {
				this.loading++;
				await this.$store.dispatch('giftcard/getDeliveryOptions');
				this.loading--;
			}
		}
	},
	watch: {
		form: {
			deep: true,
			handler(form) {
				if (form) {
					this.$emit('update:giftcard', new GiftCardPurchaseDetails(form));
				}
			},
			immediate: true
		},

		giftcard: {
			deep: true,
			handler(giftCard) {
				if (giftCard && !isEqual({ ...giftCard }, this.form)) {
					this.form = { ...giftCard };
				}
			},
			immediate: true
		}
	},
	created() {
		// Allow predefining values on the giftcard
		// let amountUrlParameter = parseInt(this.$route.query.amount);

		// if (this.isAmountValid(amountUrlParameter)) {
		// 	this.form.amount = amountUrlParameter;
		// }

		this.fetchDeliveryOptions();
	}
};
</script>

<style lang="scss" scoped>
@import '~@/styles/variables';

.giftcard-options {
	&__list-item {
		isolation: isolate;

		&.v-list-item--active::before {
			background-color: var(--v-secondary-base);
			opacity: 1;
			z-index: -1;
		}
	}

	&__icon {
		//background-color: var(--v-accent-base);
		width: 5rem;
		height: 3.5rem;
		justify-content: center;
		//clip-path: polygon(0 25%, 100% 0%, 100% 75%, 0% 100%);

		& > i {
			font-size: 2.25rem;
		}

		@media #{map-get($display-breakpoints, 'xs-only')} {
			width: 4rem;
			height: 3rem;

			& > i {
				font-size: 2rem;
			}
		}
	}

	&__title {
		@media #{map-get($display-breakpoints, 'xs-only')} {
			font-size: 0.875rem;
		}
	}

	&__subtitle {
		-webkit-line-clamp: unset !important;
	}
}
</style>
